module.exports = __webpack_public_path__ + "img/om.abc262d7.svg";